import { lazy } from "react";
import { Route, Routes } from "react-router-dom";

const AntenatalCarePage = lazy(() =>
  import(
    /* webpackChunkName: "AntenatalCarePage" */ /* webpackPrefetch: true */ "./_lib/antenatal-care-page"
  ).then((module) => ({ default: module.AntenatalCarePage })),
);

export const AntenatalCareRoutes = () => (
  <Routes>
    <Route path="new" element={<AntenatalCarePage />} />
    <Route path=":encounterId" element={<AntenatalCarePage />} />
  </Routes>
);
